import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTypedSelector } from '@hooks';
import { archiveWorkspaceAction } from '@redux/actions/workspaceAction';
import { toggleArchiveWorkspaceModal } from '@redux/actions/modalAction';
import { WorkspaceItemDto } from '@api/Api';
import { CrossIcon } from '@icons';

function ArchiveWorkspaceModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const archiveModal = useTypedSelector(
    ({ modal }) => modal.archiveWorkspaceModal
  );

  const currentWorkspaceId = useTypedSelector(
    ({ workspace }) => workspace.currentWorkspaceId
  );

  const workspaceList = useTypedSelector(
    ({ workspace }) => workspace.workspaceList
  );

  const onArchive = async () => {
    if (!archiveModal?.workspace) return;
    const ws = archiveModal.workspace as WorkspaceItemDto;

    await archiveWorkspaceAction({
      workspaceId: ws.id,
      organizationId: ws.organizationId
    })(dispatch);

    dispatch(toggleArchiveWorkspaceModal(null));

    if (currentWorkspaceId === ws.id) {
      const remaining = workspaceList.filter((el) => el.id !== ws.id);
      if (remaining.length > 0) {
        navigate(`/campaigns/all/${remaining[0].id}`);
      } else {
        navigate('/');
      }
    }
  };

  return (
    <Modal
      visible={archiveModal?.visible}
      footer={null}
      destroyOnClose
      centered={true}
      closeIcon={<CrossIcon />}
      width={500}
      onCancel={() => dispatch(toggleArchiveWorkspaceModal(null))}
    >
      <div className="modal_container">
        <h2
          className="modal_container__title"
          style={{ fontSize: 22, marginBottom: '0.5em' }}
        >
          {`Archive ${archiveModal?.workspace?.name || ''}`}
        </h2>
        <p className="modal_container__subtitle">
          Archiving this workspace will freeze all activity, hide it from users,
          and invalidate invite links. An organization admin can restore it from
          the Admin Settings at any time.
        </p>
        <div className="modal_container__actions">
          <Button
            type="text"
            style={{
              marginRight: '16px',
              border: 'none',
              height: 48,
              padding: '8px 32px'
            }}
            onClick={() => dispatch(toggleArchiveWorkspaceModal(null))}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={onArchive}
            style={{
              width: 216,
              height: 48,
              padding: '8px 15px'
            }}
          >
            Archive workspace
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ArchiveWorkspaceModal;
